/**
 * Created by Qingger Corp.
 * User: ll
 * Date: 2020/06/24
 * Time: 14:44
 * Desc: 促销活动-新增/编辑
 */
import { Component, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import { IPSService } from '@/services/ipsServices';
import IPSDatePicker from '@/views/components/ips-date-picker';
import Sketch from '@/views/components/sketch';
import ProductItem from '@/views/components/productItem/productItem.vue';
import { noop } from '@/util';
import Upload from '@/views/components/upload/upload.vue';
import ImgPreview from '@/views/components/imgPreview';
import baseAPIService from '@/services/base/baseAPIService';
import { Functions } from '@/library/utils/functions';
import NewSelectSite from '@/views/components/newSelectSIte';

@Component({
  components: {
    IPSDatePicker,
    Sketch,
    ProductItem,
    Upload,
  },
})
export default class SeckillOrderDetail extends Vue {
  //  预览组件的参数

  componentKeys = ['shareCard', 'sharePoster'];

  get componentData() {
    return [
      { img: this.promotionForm.shareCardPicture, title: this.promotionForm.customName },
      { img: this.promotionForm.sharePicture, title: this.promotionForm.customName },
    ];
  }

  get relationButtonIsDisabled() {
    return this.isEdit || !this.promotionForm.code.trim() || !!this.promotionForm.opId;
  }

  // 是版单号还是商品货号 1: 货号 ，2: 版单号
  selectGoodsType = 1;

  // $refs: {
  //   form: ElForm;
  // };

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * 最终的网点列表
   * @type {number}
   */
  public finalSiteList: Array<any> = [];

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 是否禁止编辑
   * @type {boolean}
   */
  public isEdit = false;

  public promotionForm: ItemObject = {
    opId: 0,
    code: '',
    customName: '',
    addTime: '',
    beforeBeginTime: '',
    shareCardPicture: '',
    sharePicture: '',
    actImage: '',
    empCode: '',
    promotionInfo: {
      proCode: '',
      proName: '',
      startTime: '',
      endTime: '',
      proPara: '',
      siteCodes: [],
    },
  };

  // 是否显示在活动中心
  public actShow = true;

  public rules = {
    code: [{ required: true, message: '请输入促销编号', trigger: 'change' }],
    beforeBeginTime: [{ required: true, message: '请选择上架期间', trigger: 'change' }],
    customName: [{ required: true, message: '请输入自定义活动名称', trigger: 'change' }],
    shareCardPicture: [{ required: true, message: '请选择分享卡片封面', trigger: 'change' }],
    sharePicture: [{ required: true, message: '请选择分享海报封面', trigger: 'change' }],
  };

  /**
   * 错误图片
   */
  public errorImg: any = require('../../../../static/img/bg_pic.png');

  public uploadShareCardPictureSuccess(res: any): void {
    this.promotionForm.shareCardPicture = res.content;
    this.promotionForm.actImage = res.content;
  }

  public uploadSharePictureSuccess(res: any): void {
    this.promotionForm.sharePicture = res.content;
  }

  public onDeletePic(key) {
    this.promotionForm[key] = '';
  }

  public onMagnifyPic(key) {
    ImgPreview.open({ img: this.promotionForm[key] }).then(noop, noop);
  }

  /**
   * 新增适用网点
   * @return null
   */
  public onAddSite(): void {
		new NewSelectSite()
      .open({
        service: 'authTree',
        selectCodes: this.promotionForm.promotionInfo.siteCodes || [],
        readonly: true,
      })
      .then((res) => {}, noop);
  }

  /**
   * 图片上传失败
   * @return null
   */
  public uploadImgError(): void {
    this.$message.error('图片上传失败');
  }

  /**
   * 图片上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUpload(file: ItemObject): boolean {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 1024;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 1M!');
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 关联活动
   * @returns {null}
   */
  public relation(val): void {
    const loading
      = (val.lock && val)
      || this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(225,225,225,0.3)',
        target: document.querySelector('#edit') as any,
      });
    IPSService.getOMSPromotionInfo({
      postParams: {
        proCode: this.promotionForm.code,
      },
    })
      .then((response) => {
        loading.close();
        if (!response.proCode) {
          this.$message.warning('暂无该活动');
          return;
        }
        this.promotionForm.promotionInfo = Object.assign(response, {
          startTime: Functions.timeFormatSec(response.startTime),
          endTime: Functions.timeFormatSec(response.endTime),
        });
      })
      .catch(() => {
        loading.close();
      });
  }

  /**
   * 新增/编辑促销活动
   * @return null
   */
  public onSaveConfig(): void {
    if (this.isEdit) {
      this.$router.push({
        path: '/promotionDetailEdit',
        query: {
          id: this.promotionForm.opId,
          flag: `${Number(this.isEdit)}`,
        },
      });
      return;
    }
    // @ts-expect-error
    this.$refs.form.validate((flag) => {
      if (flag) {
        if (!this.promotionForm.promotionInfo.proCode) {
          this.$message.warning('请关联促销活动');
          return;
        }
        if (this.actShow && !this.promotionForm.actImage) {
          this.$message.warning('请选择展示在活动中心的封面');
          return;
        }
        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(225,225,225,0.3)',
        });

        IPSService.editPromotion({
          postParams: {
            opId: this.promotionForm.opId,
            code: this.promotionForm.promotionInfo.proCode,
            customName: this.promotionForm.customName,
            beforeBeginTime: Math.ceil(this.promotionForm.beforeBeginTime / 1000),
            shareCardPicture: this.promotionForm.shareCardPicture,
            sharePicture: this.promotionForm.sharePicture,
            actImage: this.actShow ? this.promotionForm.actImage : '',
            empCode: this.$store.state.empCode,
          },
        })
          .then((res) => {
            loading.close();
            if (res) {
              this.$message.success('保存成功');
              this.$router.push({
                path: '/promotionDetailEdit',
                query: {
                  id: res.result,
                  flag: `${Number(this.isEdit)}`,
                },
              });
            }
          })
          .catch(() => {
            loading.close();
          });
      }
    });
  }

  /**
   * 获取促销活动详情
   * @return {null}
   */
  public getPromotionInfo() {
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
      target: document.querySelector('#edit') as any,
    });
    this.finalSiteList = [];
    const postParams = {
      // @ts-expect-error
      opId: Math.trunc(this.$route.query.id),
    };
    IPSService.promotionInfo({ postParams })
      .then((response) => {
        this.promotionForm = response;
        this.promotionForm.beforeBeginTime = this.promotionForm.beforeBeginTime * 1000;
        this.promotionForm.promotionInfo.startTime = Functions.timeFormatSec(this.promotionForm.promotionInfo.startTime);
        this.promotionForm.promotionInfo.endTime = Functions.timeFormatSec(this.promotionForm.promotionInfo.endTime);
        if (this.promotionForm.actImage) {
          this.actShow = true;
        } else {
          this.actShow = false;
        }
        loading.close();
        // 陈斯说获取详情时 不需要调此接口
        // this.relation(loading);
      })
      .catch(() => {
        loading.close();
      });
  }

  /**
   * 返回列表页
   * @return null
   */
  public goBack(): void {
    this.$router.push({
      path: '/promotionActivity',
    });
  }

  public mounted(): void {
    this.isEdit = !!Number(this.$route.query.flag || 0);
    // @ts-expect-error
    this.promotionForm.opId = Math.trunc(this.$route.query.id) || 0;
    if (this.$route.query.id) {
      this.getPromotionInfo();
    }
  }

  /**
   * 促销编号输入框失焦
   * @returns {null}
   */
  public onBlur() {
    if (!this.promotionForm.code.trim()) {
      this.promotionForm.code = this.promotionForm.promotionInfo.proCode || this.promotionForm.code;
    }
  }

  /**
   * 促销编号输入
   * @returns {null}
   */
  public onInput(val) {
    this.promotionForm.code = val;
  }

  /**
   * 上传活动中心图片
   */
  public uploadActivityPicSuccess(res) {
    this.promotionForm.actImage = res.content;
  }

  /**
   * 是否展示在活动中心
   */
  public onChange(val) {
    if (val && !this.promotionForm.actImage) {
      this.promotionForm.actImage = this.promotionForm.shareCardPicture;
    }
  }
}
